import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useTranslation from "../../hooks/traslation";
import { GRAPH_TYPE } from "../../utils/enums";
import { useEffect, useState } from "react";
import { showError } from "../../constants/toasts";
import { useLazyGetTaskGraphQuery } from "../../services/dashboard";

const IssuesGraph = () => {
  const translation = useTranslation();
  const [isTaskLoading, setIsTaskLoading] = useState(false);
  const [TaskGraphType, setTaskGraphType] = useState(GRAPH_TYPE.DAY);
  const [taskData, setTaskData] = useState([]);
  const [getTaskGraph] = useLazyGetTaskGraphQuery();

  //taskData
  const TaskGraph = async () => {
    setIsTaskLoading(true);
    try {
      const response = await getTaskGraph({
        type: TaskGraphType,
      }).unwrap();
      if (response?.statusCode === 200) {
        setTaskData(response?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsTaskLoading(false);
    }
  };

  const handleTaskTaskGraphTypeChange = (type: GRAPH_TYPE) => {
    setTaskGraphType(type);
    TaskGraph();
  };
  useEffect(() => {
    TaskGraph();
  }, [TaskGraphType]);

  return (
    <>
      <div className="cards table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>{translation.main.Tasks}</h2>
          </div>
          <div className="right_s">
            <p>
              <span
                className={`time-period ${
                  TaskGraphType === GRAPH_TYPE.DAY ? "active" : ""
                }`}
                onClick={() => handleTaskTaskGraphTypeChange(GRAPH_TYPE.DAY)}
              >
                {translation.main.aday}
              </span>
              <span
                className={`time-period ${
                  TaskGraphType === GRAPH_TYPE.WEEK ? "active" : ""
                }`}
                onClick={() => handleTaskTaskGraphTypeChange(GRAPH_TYPE.WEEK)}
              >
                {translation.main.aweek}
              </span>
              <span
                className={`time-period ${
                  TaskGraphType === GRAPH_TYPE.MONTH ? "active" : ""
                }`}
                onClick={() => handleTaskTaskGraphTypeChange(GRAPH_TYPE.MONTH)}
              >
                {translation.main.amonth}
              </span>
              <span
                className={`time-period ${
                  TaskGraphType === GRAPH_TYPE.YEAR ? "active" : ""
                }`}
                onClick={() => handleTaskTaskGraphTypeChange(GRAPH_TYPE.YEAR)}
              >
                {translation.main.ayear}
              </span>
            </p>
          </div>
        </div>
        <div className="graph-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={taskData}
              style={{ fontSize: 12 }}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 60,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={60}
                interval={0}
                tickFormatter={(value) => {
                  if (typeof value === "string") {
                    return (
                      value.charAt(0).toUpperCase() +
                      value.slice(1).toLowerCase()
                    );
                  }
                  return value;
                }}
              />
              <YAxis tick={{ fontSize: 10 }} width={80} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
              <Bar
                dataKey="value"
                fill="#BF2F17"
                radius={[4, 4, 0, 0]}
                barSize={40}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default IssuesGraph;
